//
//
//
//

export default {
    data: function data() {
        return {
            added: 0
        };
    },
    created: function created() {
        var _this = this;

        App.event.listen('cart.data.loaded', function (_ref) {
            var data = _ref.data;

            _this.added = data.count;
        });

        App.event.listen('cart.updated', function (_ref2) {
            var data = _ref2.data;

            _this.added = data.count;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/cart-num-items/components/CartNumItems.vue
// module id = tvHb
// module chunks = 4